import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Styles = styled.div`
    border-radius: var(--border-radius-32);
    background-color: var(--n-grey-0);
    box-shadow: 0px 23px 40px -13px #00000014;
    position: relative;
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
        border-radius: calc(var(--border-radius-32) + 1px);
    }
`
export default function BoxDesign ({style, className, children}){
  return (
    <Styles style={style} className={className}>
      {children}
    </Styles>
  )
}

